import { Platform } from 'react-native'

import Skeleton from 'app/components/base/Skeleton'
import Stack, { StackProps } from 'app/components/base/Stack'
import Location from 'app/components/common/Location'
import UserRating from 'app/components/common/UserRating'

type LocationWithUserRatingProps = {
  location?: string
  isLoading?: boolean
  rating?: number
  isBusinessUser?: boolean
  sx?: StackProps['sx']
}

const LocationWithUserRating: RFC<LocationWithUserRatingProps> = ({
  location = null,
  isLoading,
  rating,
  isBusinessUser,
  sx
}) => {
  const textColor = isBusinessUser ? 'primary.main' : 'common.white'

  return (
    <Stack
      spacing={{ md: 2, xs: 1 }}
      sx={{
        ...Platform.select({ native: { flexDirection: 'column' } }),
        ...sx
      }}
      {...Platform.select({
        web: { direction: { md: 'row', xs: 'column' } }
      })}
    >
      {!!location && (
        <Location
          location={location}
          loading={isLoading}
          textVariant="body1"
          textColor={textColor}
          withGoogleMapLink
        />
      )}

      <Skeleton loading={isLoading} sx={{ width: { xs: '30%', md: 0 } }}>
        <UserRating rating={rating} type="secondary" textColor={textColor} />
      </Skeleton>
    </Stack>
  )
}

export default LocationWithUserRating
